<div class="loader">
    <div class="dimmed" [hidden]="status != STATUS_LOADING">
        <div class="dimmed_flex">
            <div class="dimmed_status"></div>
        </div>
    </div>
</div>
<div class="version-info" [ngClass]="{'with-overlay': view != VIEW_APPROVAL_NONE}" *ngIf="status == STATUS_DONE">
  <core-layout-modal-message-one-action class="modal-feedback modal-feedback-approve" *ngIf="view == VIEW_APPROVAL_APPROVE_MODAL"
        [disabled]="approvalActionDisabled"
        [emojis]="false"
        [title]="'Your Feedback'"
        [messagePlaceholder]="'Provide reasons/instructions for your approval.'"
        [text]="'Are you sure you are ready? <em>Once you approve a file you <strong>cannot go back</strong> to add notes or messages.</em>'"
        [buttonText]="'Approve'"
        [buttonType]="'green'"
        (buttonClick)="approve($event)"
        (buttonCloseClick)="dismiss($event)"
        >
    </core-layout-modal-message-one-action>
    <core-layout-modal-message-one-action class="modal-feedback modal-feedback-rejection" *ngIf="view == VIEW_APPROVAL_REJECT_MODAL"
        [disabled]="approvalActionDisabled"
        [emojis]="false"
        [title]="'Your Feedback'"
        [messagePlaceholder]="'Provide reasons/instructions for your rejection.'"
        [text]="'Are you sure you are ready? <em>Once you reject a file you <strong>cannot go back</strong> to add notes or messages.</em>'"
        [buttonText]="'Reject'"
        [buttonType]="'red'"
        (buttonClick)="reject($event)"
        (buttonCloseClick)="dismiss($event)"
        >
    </core-layout-modal-message-one-action>
    <core-layout-modal-feedback class="modal-feedback modal-feedback-set-pass" *ngIf="view == VIEW_APPROVAL_SET_PASS_MODAL"
        [type]="'warning'"
        [message]="'Password required'"
        [text]="'This approval requires a digital signature. You need to configure your password before the approval can be completed.'"
        [buttonText]="'Go Back'"
        (action)="onPassRequiredDone($event)">
    </core-layout-modal-feedback>
    <ng-container [ngSwitch]="signatureType" *ngIf="view == VIEW_APPROVAL_APPROVE_SIGNATURE">
        <ng-template [ngSwitchCase]="SIGNATURE_TYPES_ENUM.CFR11_COMPLETE ">
            <!-- TODO: to manage pinsresend status error success -->
            <core-layout-modal-cfr11-digital-signature 
                [disabled]="signDisabled"
                [signatureType]="signatureType"
                [pinRequestStatus]="pinRequestStatus"
                (mainAction)="cfr11SignFeedback($event)"
                (secondAction)="dismiss($event)"
                (pinRequestAction)="onNewPinRequest($event)"
            ></core-layout-modal-cfr11-digital-signature>
        </ng-template>
        <ng-template [ngSwitchDefault]>
            <!-- by now case for signature short and default signature are same -->
            <ng-container *ngIf="signatureType == SIGNATURE_TYPES_ENUM.DEFAULT || signatureType == SIGNATURE_TYPES_ENUM.CFR11_SHORT">
                <core-layout-modal-signature
                    [disabled]="signDisabled"
                    [title]="'Your signature is required'"
                    [placeholder]="'Introduce your password'"
                    [text]="'You must verify your approval by typing your password below.'"
                    [buttonText]="'Sign'"
                    (mainAction)="signApprove($event)"
                    [secondButtonText]="'Go back'"
                    (secondAction)="dismiss($event)"
                    (ssoAction)="onSsoSign($event)"
                ></core-layout-modal-signature>
            </ng-container>
        </ng-template>
    </ng-container>
    <core-layout-modal-feedback class="modal-feedback modal-feedback-success" *ngIf="view == VIEW_APPROVAL_DONE"
        [type]="'done'"
        [message]="'Feedback Sent'"
        [text]="'Your feedback has been successfully sent'"
        [buttonText]="'Done'"
        (action)="onFeedbackSent($event)">
    </core-layout-modal-feedback>
    <!-- modal error on backend calls -->
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_FEEDBACK_ACTION_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'Something went wrong. Please try again. If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'Retry'"
        (action)="dismiss($event)">
    </core-layout-modal-feedback>
    <!-- modal error on approve/reject wrong content backend calls -->
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_APPROVAL_ACTION_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'You have some invalid content inside your text, please review your message and try again.'"
        [buttonText]="'Retry'"
        (action)="dismiss($event)">
    </core-layout-modal-feedback>
    <!-- modal error on wrong signature -->
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_APPROVAL_SIGNATURE_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'Not authorized. Please try again with valid credentials.'"
        [buttonText]="'Retry'"
        (action)="retry($event)">
    </core-layout-modal-feedback>
    <!-- to display the component for each feedback type -->
    <ng-container *ngIf="accessFeedbacks && versionSharesList != null">
        <ng-container *ngIf="userApproval != null">
            <core-versions-approval-box
                [version]="version"
                [versionShare]="userApproval"
                (actionApprove)="onApprove($event)"
                (actionReject)="onReject($event)"
            ></core-versions-approval-box>
        </ng-container>
        <!-- in case upload-version -->
        <ng-container  *ngIf="userVersionUpload != null">
            <!-- display status for upload version request -->
            <div class="request-upload-artwork">
                <core-versions-upload-version-box
                    [version]="version"
                    [project]="project"
                    [versionShare]="userVersionUpload"
                    [uploadVersion]="currentVersionShare"
                ></core-versions-upload-version-box>
            </div>
        </ng-container>
        <!-- in case feedback without approval -->
        <ng-container  *ngIf="userFeedback != null">
            <!-- display status for feedback with no approval -->
            <core-versions-completed-box  
                [version]="version"
                [versionShare]="userFeedback" 
                (actionComplete)="complete($event)"></core-versions-completed-box>
        </ng-container>
    </ng-container>     

    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_SHARE_UPDATE_STATUS_FORBIDDEN"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'This share could NOT be updated. Please contact your admin for additional support.'"
        [buttonText]="'OK'"
        (action)="dismissArchiveAction($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_SHARE_RESET_FORBIDDEN"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'This share could NOT be reset. Please contact your admin for additional support.'"
        [buttonText]="'OK'"
        (action)="dismissResetAction($event)">
    </core-layout-modal-feedback>
    <core-versions-detail-box
        [version]="version"
    ></core-versions-detail-box>
    <!-- List of user version shares with new bubbles we got as VersionShare object in this case -->
    <core-version-shares-status-list 
        *ngIf="accessFeedbacks"
        [versionShareBubbles]="versionSharesList"
        [menu]="sharesMenu"
        (menuClick)="onSharesMenuClick($event)"
    ></core-version-shares-status-list>
</div>
